import {useQuery} from '@tanstack/react-query';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { SolicitudesUsuariosPedido, ISolicitudesPedidoPagingRes } from '@/shared/interfaces';
import { getUrlParamsFetch, handleAxiosError } from '@/shared';

const { get } = erpApi();

///* tanSctack query



export const useGetSolicitudesUsuariosPedido = (params?: GetSolicitudesUsuariosPedidosParams) => {
  return useQuery({
    queryKey: ['solicitud-pedidos', ...Object.values(params || {})],
    queryFn: async () => {
      return GetSolicitudesPedidosUsuarios(params);
    },
  });
};


export const GetSolicitudesPedidosUsuarios = async (params?: GetSolicitudesUsuariosPedidosParams) => {
  const queryParams = getUrlParamsFetch({ ...params });

  return get<ISolicitudesPedidoPagingRes>(
    `${urlBackend}api/v1/solicitud-egreso/?${queryParams}`,
    true
  );
};
export const useGetSolicitudUsuariosPedido = (id: string) => {
  return useQuery({
    queryKey: ['solicitud-pedidos', id],
    queryFn: async () => {
      return getSolicitudesUsuariosPedido(id);
    },
  });
};
 
  ///* axios
  export type GetSolicitudesUsuariosPedidosParams = {
    page?: number;
    page_size?: number;
    nombre?: string;
    numero_referencia?: number;
    estado_solicitud?: string;
    fecha_after?: string;
    fecha_before?: string;
  };
  
  export const getSolicitudesUsuariosPedido = async (id: string) => {
    try{
      return await get<SolicitudesUsuariosPedido>(`${urlBackend}api/solicitud-egreso/${id}/`, true);
    }
    catch(error){
      return handleAxiosError(error);
    }

  };
  